export default {
  title: '連絡先',
  edit: '連絡先を編集',
  success: '連絡先情報が正常に保存されました'
}
